module.exports = __webpack_public_path__ + "img/product01-2.ef3b9d2a.png";